import { keyframes } from '@emotion/react';

export const widthAnimation = keyframes`
  from { width: 0; }
  to { width: 100%; }
`;

export const pulsate = keyframes`
  0% { opacity: 1 }
  50% { opacity: .4 }
  100% { opacity: 1 }
`;

export const growSm = keyframes`
  0% { scale: 1; }
  50% { scale: 1.2; }
  100% { scale: 1; }
`;

export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const fadeScaleInSm = keyframes`
  0% { opacity: 0; transform: scale(.9); }
  100% { opacity: 1; transform: scale(1); }
`;

export const swingSm = keyframes`
  0% { transform: rotateZ(-2deg); }
  25% { transform: rotateZ(8deg); }
  75% { transform: rotateZ(-12deg); }
  100% { transform: rotateZ(-2deg); }
`;

export const scrollY50 = keyframes`
  0% { transform: translateY(0%); }
  100% { transform: translateY(-50%); }
`;

export const flip = keyframes`
  0% {transform: rotateY(0deg)}
  10% {transform: rotateY(180deg)}
  90% {transform: rotateY(180deg)}
  100% {transform: rotateY(0deg)}
`;
